export const NL = {
  // Cookie banner
  "Your privacy at ESAIA": "Uw privacy bij ESAIA",
  "ESAIA uses only strictly necessary cookies to keep this website secure and your session active. We do not use advertising or tracking cookies. Read our": "ESAIA gebruikt uitsluitend strikt noodzakelijke cookies om deze website veilig te houden en uw sessie actief te houden. Wij gebruiken geen advertentie- of trackingcookies. Lees ons",
  "Cookie Policy": "Cookiebeleid",
  "Decline": "Weigeren",
  "Accept": "Accepteren",

  // Auth
  "ESAIA Portal": "ESAIA Portaal",
  "Back to website": "Terug naar website",
  "Transparent. Accountable. Ethical.": "Transparant. Verantwoordelijk. Ethisch.",
  "Login": "Inloggen",
  "Log in": "Inloggen",
  "Log out": "Uitloggen",
  "Sign in to your ESAIA portal.": "Log in op uw ESAIA-portaal.",
  "Email": "E-mail",
  "Password": "Wachtwoord",
  "Log In": "Inloggen",
  "Signing in...": "Bezig met inloggen...",
  "Forgot Password?": "Wachtwoord vergeten?",
  "Create Account": "Account aanmaken",
  "Create your ESAIA Account": "Maak uw ESAIA-account aan",
  "Access your assessments, reports and certificates in the Client Portal.": "Bekijk uw assessments, rapporten en certificaten in het Clientportaal.",
  "First name": "Voornaam",
  "Last name": "Achternaam",
  "Company": "Bedrijf",
  "Job title": "Functietitel",
  "Country": "Land",
  "Phone number": "Telefoonnummer",
  "Confirm password": "Bevestig wachtwoord",
  "Minimum 8 characters, with a letter and a number.": "Minimaal 8 tekens, met een letter en een cijfer.",
  "I agree to the": "Ik ga akkoord met de",
  "ESAIA Terms": "ESAIA-voorwaarden",
  "and": "en",
  "Privacy Policy": "Privacybeleid",
  "Creating account...": "Account wordt aangemaakt...",
  "Already have an account?": "Heeft u al een account?",
  "Your ESAIA account has been created.": "Uw ESAIA-account is aangemaakt.",
  "Forgot your password?": "Wachtwoord vergeten?",
  "Enter your email address and we'll send you a secure link to reset your password.": "Voer uw e-mailadres in en wij sturen u een veilige link om uw wachtwoord opnieuw in te stellen.",
  "Send Reset Link": "Verstuur resetlink",
  "Sending...": "Verzenden...",
  "If an account exists for this email address, you will receive a password reset link.": "Als er een account bestaat voor dit e-mailadres, ontvangt u een link om uw wachtwoord opnieuw in te stellen.",
  "Return to Login": "Terug naar inloggen",
  "Reset Password": "Wachtwoord opnieuw instellen",
  "Choose a new password for your ESAIA account.": "Kies een nieuw wachtwoord voor uw ESAIA-account.",
  "New password": "Nieuw wachtwoord",
  "Confirm new password": "Bevestig nieuw wachtwoord",
  "Updating...": "Bijwerken...",
  "Your password has been updated successfully.": "Uw wachtwoord is succesvol bijgewerkt.",
  "This reset link is missing its token. Please use the link from your email.": "Deze resetlink mist zijn token. Gebruik de link uit uw e-mail.",
  "Change Password": "Wachtwoord wijzigen",
  "Update the password of your ESAIA account.": "Wijzig het wachtwoord van uw ESAIA-account.",
  "For security reasons, you must create a new password before continuing.": "Om veiligheidsredenen moet u een nieuw wachtwoord aanmaken voordat u verdergaat.",
  "Current password": "Huidig wachtwoord",
  "Password successfully updated.": "Wachtwoord succesvol bijgewerkt.",
  "Something went wrong. Please try again.": "Er ging iets mis. Probeer het opnieuw.",
  "Invalid email or password.": "Ongeldig e-mailadres of wachtwoord.",
  "Your session has expired. Please log in again.": "Uw sessie is verlopen. Log opnieuw in.",
  "You do not have permission to access this resource.": "U heeft geen toegang tot deze bron.",
  "My Portal": "Mijn portaal",

  // Client portal
  "Client Portal": "Clientportaal",
  "Dashboard": "Dashboard",
  "Assessments": "Assessments",
  "Certificates": "Certificaten",
  "Request a Service": "Dienst aanvragen",
  "Account": "Account",
  "Help": "Help",
  "Log Out": "Uitloggen",
  "Loading...": "Laden...",
  "Welcome,": "Welkom,",
  "Active Assessments": "Actieve assessments",
  "Completed Assessments": "Afgeronde assessments",
  "Latest Updates": "Laatste updates",
  "No updates yet.": "Nog geen updates.",
  "My Assessments": "Mijn assessments",
  "All ESAIA assessments and ERI results for your organization.": "Alle ESAIA-assessments en ERI-resultaten voor uw organisatie.",
  "No assessments yet.": "Nog geen assessments.",
  "Start:": "Start:",
  "Completed": "Afgerond",
  "Score": "Score",
  "Back to Assessments": "Terug naar assessments",
  "Start Date": "Startdatum",
  "Completion Date": "Afrondingsdatum",
  "Last Updated": "Laatst bijgewerkt",
  "Assessment ID": "Assessment-ID",
  "Assessment Summary": "Assessmentsamenvatting",
  "ERI Results": "ERI-resultaten",
  "Key Findings": "Belangrijkste bevindingen",
  "Risk Summary": "Risicosamenvatting",
  "Recommendations": "Aanbevelingen",
  "Management Summary": "Managementsamenvatting",
  "Additional Notes": "Aanvullende notities",
  "Assessment Progress": "Voortgang assessment",
  "Management Reports": "Managementrapporten",
  "No management reports have been uploaded for this assessment.": "Er zijn nog geen managementrapporten geüpload voor dit assessment.",
  "View": "Bekijken",
  "Download": "Downloaden",
  "ERI Result": "ERI-resultaat",
  "Key Attention Areas": "Belangrijkste aandachtspunten",
  "My Certificates": "Mijn certificaten",
  "Your complete ESAIA certification history. Expired certificates remain visible for reference.": "Uw volledige ESAIA-certificeringsgeschiedenis. Verlopen certificaten blijven zichtbaar ter referentie.",
  "No certificates have been uploaded yet.": "Er zijn nog geen certificaten geüpload.",
  "Certificate:": "Certificaat:",
  "View Certificate": "Certificaat bekijken",
  "Download PDF": "PDF downloaden",
  "Request an ESAIA Service": "Vraag een ESAIA-dienst aan",
  "Select a service below. ESAIA will review your request and open an assessment.": "Selecteer hieronder een dienst. ESAIA beoordeelt uw aanvraag en opent een assessment.",
  "Free initial AI readiness assessment.": "Gratis initiële AI-readiness assessment.",
  "Start ERI": "Start ERI",
  "For organizations with 1 to 10 legal entities.": "Voor organisaties met 1 tot 10 rechtspersonen.",
  "Request Certification": "Certificering aanvragen",
  "For organizations with more than 10 entities or large/complex structures.": "Voor organisaties met meer dan 10 entiteiten of grote/complexe structuren.",
  "Request Group-Wide Assessment": "Group-Wide assessment aanvragen",
  "Annual Recertification": "Jaarlijkse hercertificering",
  "For existing ESAIA-certified organizations.": "Voor bestaande ESAIA-gecertificeerde organisaties.",
  "Request Recertification": "Hercertificering aanvragen",
  "My Service Requests": "Mijn dienstaanvragen",
  "No service requests yet.": "Nog geen dienstaanvragen.",
  "Add a short message for the ESAIA team (optional).": "Voeg een kort bericht toe voor het ESAIA-team (optioneel).",
  "Context, number of entities, timelines...": "Context, aantal entiteiten, planning...",
  "Submit Request": "Aanvraag versturen",
  "Submitting...": "Versturen...",
  "Your service request has been submitted.": "Uw dienstaanvraag is verstuurd.",
  "My Account": "Mijn account",
  "Account created": "Account aangemaakt",
  "Profile Information": "Profielinformatie",
  "Save Changes": "Wijzigingen opslaan",
  "Saving...": "Opslaan...",
  "Security": "Beveiliging",
  "Your account information has been updated.": "Uw accountgegevens zijn bijgewerkt.",
  "Phone": "Telefoon",

  // Statuses
  "ACTIVE": "ACTIEF",
  "COMPLETED": "AFGEROND",
  "PENDING": "IN AFWACHTING",
  "EXPIRED": "VERLOPEN",
  "Requested": "Aangevraagd",
  "Under Review": "In behandeling",
  "Active": "Actief",
  "Declined": "Afgewezen",
  "Valid": "Geldig",
  "Expired": "Verlopen",
  "Not found": "Niet gevonden",

  // Admin portal
  "Admin Portal": "Beheerportaal",
  "ERI": "ERI",
  "Mail": "Mail",
  "Clients": "Cliënten",
  "Administrator": "Beheerder",
  "ERI Submissions": "ERI-inzendingen",
  "Every completed Ethical Readiness Index, newest first.": "Elke voltooide Ethical Readiness Index, nieuwste eerst.",
  "Search name, company, email": "Zoek naam, bedrijf, e-mail",
  "All": "Alle",
  "Attention required": "Aandacht vereist",
  "Developing": "In ontwikkeling",
  "Established": "Gevestigd",
  "Name": "Naam",
  "Date": "Datum",
  "Readiness": "Readiness",
  "Client": "Cliënt",
  "Linked": "Gekoppeld",
  "Not linked": "Niet gekoppeld",
  "No ERI submissions yet.": "Nog geen ERI-inzendingen.",
  "Previous": "Vorige",
  "Next": "Volgende",
  "Page": "Pagina",
  "of": "van",
  "Back to ERI Submissions": "Terug naar ERI-inzendingen",
  "Contact Information": "Contactgegevens",
  "Date completed": "Datum voltooid",
  "Client Link": "Cliëntkoppeling",
  "Linked to": "Gekoppeld aan",
  "Not linked to a client account.": "Niet gekoppeld aan een cliëntaccount.",
  "Select client...": "Selecteer cliënt...",
  "Link to Client": "Koppel aan cliënt",
  "Update Link": "Koppeling bijwerken",
  "Submission updated.": "Inzending bijgewerkt.",
  "Risk indicators": "Risico-indicatoren",
  "Answers": "Antwoorden",
  "Detailed answers are available for submissions completed after the portal launch.": "Gedetailleerde antwoorden zijn beschikbaar voor inzendingen die na de lancering van het portaal zijn voltooid.",
  "Question": "Vraag",
  "Answer:": "Antwoord:",
  "Communications received through ESAIA for info@esaia.org.": "Communicatie ontvangen via ESAIA voor info@esaia.org.",
  "unread.": "ongelezen.",
  "Inbox": "Inbox",
  "Unread": "Ongelezen",
  "Archive": "Archief",
  "Search sender or subject": "Zoek afzender of onderwerp",
  "No emails yet.": "Nog geen e-mails.",
  "Select an email to read it.": "Selecteer een e-mail om te lezen.",
  "From:": "Van:",
  "Client linked": "Cliënt gekoppeld",
  "Mark as Unread": "Markeer als ongelezen",
  "Mark as Read": "Markeer als gelezen",
  "Restore": "Herstel",
  "Link to client...": "Koppel aan cliënt...",
  "Marked as unread.": "Gemarkeerd als ongelezen.",
  "Marked as read.": "Gemarkeerd als gelezen.",
  "Archived.": "Gearchiveerd.",
  "Restored to inbox.": "Hersteld naar inbox.",
  "Client link updated.": "Cliëntkoppeling bijgewerkt.",
  "Every registered client organization.": "Elke geregistreerde cliëntorganisatie.",
  "Latest activity": "Laatste activiteit",
  "Status": "Status",
  "No clients registered yet.": "Nog geen cliënten geregistreerd.",
  "Back to Clients": "Terug naar cliënten",
  "Client Information": "Cliëntgegevens",
  "Account created:": "Account aangemaakt:",
  "Client information updated.": "Cliëntgegevens bijgewerkt.",
  "ERI History": "ERI-geschiedenis",
  "No ERI submissions linked to this client.": "Geen ERI-inzendingen gekoppeld aan deze cliënt.",
  "Related Emails": "Gerelateerde e-mails",
  "No emails linked to this client.": "Geen e-mails gekoppeld aan deze cliënt.",
  "Add Assessment": "Assessment toevoegen",
  "Type": "Type",
  "Updated": "Bijgewerkt",
  "Create a new assessment for": "Maak een nieuw assessment voor",
  "Assessment type": "Assessmenttype",
  "Start date": "Startdatum",
  "Target completion": "Streefdatum afronding",
  "Internal notes": "Interne notities",
  "Create Assessment": "Assessment aanmaken",
  "Assessment created.": "Assessment aangemaakt.",
  "Service Requests": "Dienstaanvragen",
  "No service requests.": "Geen dienstaanvragen.",
  "Request status updated.": "Aanvraagstatus bijgewerkt.",
  "Back to": "Terug naar",
  "Internal notes (never shown to the client)": "Interne notities (nooit zichtbaar voor de cliënt)",
  "Assessment updated.": "Assessment bijgewerkt.",
  "Assessment Activities": "Assessmentactiviteiten",
  "Upload PDF Report": "PDF-rapport uploaden",
  "Management report uploaded.": "Managementrapport geüpload.",
  "Report deleted.": "Rapport verwijderd.",
  "Assessment Summary (publish per field to the client portal)": "Assessmentsamenvatting (publiceer per veld naar het clientportaal)",
  "Visible to client": "Zichtbaar voor cliënt",
  "Summaries saved.": "Samenvattingen opgeslagen.",
  "Upload Certificate (PDF)": "Certificaat uploaden (PDF)",
  "Certificate Number": "Certificaatnummer",
  "Certification type": "Certificeringstype",
  "Expiry date": "Vervaldatum",
  "Status (automatic by expiry date; override only if needed)": "Status (automatisch op vervaldatum; alleen overschrijven indien nodig)",
  "Automatic": "Automatisch",
  "Force ACTIVE": "Forceer ACTIEF",
  "Force EXPIRED": "Forceer VERLOPEN",
  "Upload Certificate": "Certificaat uploaden",
  "Certificate uploaded.": "Certificaat geüpload.",
  "Certificate updated.": "Certificaat bijgewerkt.",
  "Certificate deleted.": "Certificaat verwijderd.",
  "uploaded": "geüpload",
  "Please select a certificate PDF.": "Selecteer een certificaat-PDF.",

  // Checklist items
  "Scope defined": "Scope bepaald",
  "AI environment reviewed": "AI-omgeving beoordeeld",
  "AI systems identified": "AI-systemen geïdentificeerd",
  "AI agents identified": "AI-agenten geïdentificeerd",
  "Governance reviewed": "Governance beoordeeld",
  "Risk assessment completed": "Risicobeoordeling voltooid",
  "Documentation reviewed": "Documentatie beoordeeld",
  "Human oversight reviewed": "Menselijk toezicht beoordeeld",
  "Transparency reviewed": "Transparantie beoordeeld",
  "Accountability reviewed": "Verantwoordelijkheid beoordeeld",
  "Findings documented": "Bevindingen gedocumenteerd",
  "Recommendations completed": "Aanbevelingen voltooid",
  "Management report uploaded": "Managementrapport geüpload",
  "Certification decision completed": "Certificeringsbeslissing voltooid",
};
